//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import mixins from '../mixins/index'
export default {
  name: 'dnaer-star',
  mixins: [mixins],
  data () {
    return {
      downloadUrl: '',
      isShowMask: false,
    }
  },
  mounted () {
    this.handleGetMobelType()
    this.handleGetNewVersion()
  },
  methods: {
    handleChangeMaskShow () {
      this.isShowMask = !this.isShowMask
    },
    handleGetMobelType () {
      let browser = { }
      let u = window.navigator.userAgent
      browser = {
        trident: u.indexOf('Trident') > -1,
        presto: u.indexOf('Presto') > -1,
        Alipay: u.indexOf('Alipay') > -1,
        webKit: u.indexOf('AppleWebKit') > -1,
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
        iPad: u.indexOf('iPad') > -1,
        webApp: u.indexOf('Safari') === -1,
        weixin: u.indexOf('MicroMessenger') > -1,
        qq: u.match(/\sQQ/i) !== null,
        Safari: u.indexOf('Safari') > -1
      }
      this.GetMobelType = browser
      this.type = this.GetMobelType.android


    },
    handlePhoneJump () {
      let _this = this
      if (this.GetMobelType.weixin) {
        this.isShowMask = true
      } else {
        if (this.GetMobelType.android) {
          window.location.href = _this.downloadUrl
        }
        if (this.GetMobelType.ios || this.GetMobelType.iPhone || this.GetMobelType.iPad) {
          if (this.GetMobelType.qq) {
            this.isShowMask = true
          } else {
            window.location.href = 'https://apps.apple.com/cn/app/dnaer叮了-实名社交系统/id1479806321?l=zh&ls=1'
          }
        }
      }
    },
    handleGetNewVersion () {
      this.axios('/plugin/unCheck/app/version/mobile/v1/lastOne',{platform: 'android'}).then((res) => {
        this.downloadUrl = res.data.data.url
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/dnaerStar.vue